// token key
export const TOKEN_KEY = 'TOKEN__';

export const LOCALE_KEY = 'LOCALE__';

// user info key
export const USER_INFO_KEY = 'USER__INFO__';

// role info key
export const ROLES_KEY = 'ROLES__KEY__';

// project config key
export const PROJ_CFG_KEY = 'PROJ__CFG__KEY__';

// lock info
export const LOCK_INFO_KEY = 'LOCK__INFO__KEY__';

export const MULTIPLE_TABS_KEY = 'MULTIPLE_TABS__KEY__';

export const APP_DARK_MODE_KEY_ = '__APP__DARK__MODE__';

// base global local key
export const APP_LOCAL_CACHE_KEY = 'COMMON__LOCAL__KEY__';

// base global session key
export const APP_SESSION_CACHE_KEY = 'COMMON__SESSION__KEY__';


export enum CacheTypeEnum {
  SESSION,
  LOCAL,
}



// 兑换商品缓存信息key
export const SUBMIT_ORDER = 'submit_order_info';
// 兑换商品选择地址缓存
export const SUBMIT_ORDER_ADDRESS = 'submit_order_select_address';
// 兑换商品选择发票缓存
export const SUBMIT_ORDER_INVOICE = 'submit_order_select_invoice';
// 订单类型缓存key 10：中智传统福利订单 20：客户VIP订单 30：生日专区订单 40：积分兑换卡订单
export const ORDER_STATUS_TYPE = 'order_status_type';
// 是否开具发票
export const SUBMIT_ORDER_IS_INVOICE = 'submit_order_is_invoice';
// 创建订单需要补充金额
export const SUBMIT_ORDER_SUPPLEMENT_MONEY = 'order_supplement_money';
// 服务单缓存key
export const AFTER_GOODS = 'service_after_Goods';
// 创建订单选择发票缓存
// export const SUBMIT_ORDER_ADDRESS = 'submit_order_select_address';